module.exports = __webpack_public_path__ + "img/stripe.05453d8c.png";